/* =============================================================================
   Cherry Tuning — Custom Boost Model chart library (window.CBM).
   Vanilla SVG charting for the i20 N boost-model page. Palette is read from the
   --cbm-* / --cy-* CSS custom properties (see cbm.css) so a brand recolour flows
   through automatically. Pairs with cbm-dyno.js (window.CBM_DYNO traced data).
   Every draw call is keyed by a host element, so a section can appear twice safely.
   ============================================================================= */
(function () {
  if (window.CBM) return;
  var NS = 'http://www.w3.org/2000/svg';

  function cssvar(name, fb) {
    try {
      var v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
      return v || fb;
    } catch (e) { return fb; }
  }
  function palette() {
    return {
      n: cssvar('--cbm-n', '#cc3333'),
      sport: cssvar('--cbm-sport', '#e8912f'),
      normal: cssvar('--cbm-normal', '#37a86a'),
      eco: cssvar('--cbm-eco', '#37a3ba'),
      stock: cssvar('--cbm-stock', '#868b93'),
      good: cssvar('--cbm-good', '#2fa869'),
      grid: cssvar('--cbm-grid', 'rgba(255,255,255,.055)'),
      axis: cssvar('--cbm-axis', '#8b9099'),
      plot: cssvar('--cbm-plot', '#141517'),
      line: cssvar('--cbm-line', 'rgba(255,255,255,.10)'),
      on: cssvar('--cbm-on', '#e9eaec'),
      onMuted: cssvar('--cbm-on-muted', '#9aa0aa')
    };
  }
  var MONO = 'ui-monospace,SFMono-Regular,Menlo,Consolas,monospace';

  /* -- catmull-rom -> smooth cubic path ------------------------------------ */
  function smooth(pts) {
    if (pts.length < 2) return '';
    var d = 'M' + pts[0].x.toFixed(1) + ',' + pts[0].y.toFixed(1);
    for (var i = 0; i < pts.length - 1; i++) {
      var p0 = pts[i - 1] || pts[i], p1 = pts[i], p2 = pts[i + 1], p3 = pts[i + 2] || p2;
      var c1x = p1.x + (p2.x - p0.x) / 6, c1y = p1.y + (p2.y - p0.y) / 6,
          c2x = p2.x - (p3.x - p1.x) / 6, c2y = p2.y - (p3.y - p1.y) / 6;
      d += ' C' + c1x.toFixed(1) + ',' + c1y.toFixed(1) + ' ' + c2x.toFixed(1) + ',' +
           c2y.toFixed(1) + ' ' + p2.x.toFixed(1) + ',' + p2.y.toFixed(1);
    }
    return d;
  }
  function resample(rp, vl, step) {
    var R = [], V = [], nx = rp[0];
    for (var i = 0; i < rp.length; i++) {
      if (rp[i] >= nx || i === rp.length - 1) { R.push(rp[i]); V.push(vl[i]); nx = rp[i] + step; }
    }
    return { rpm: R, val: V };
  }
  function el(tag, attrs) {
    var e = document.createElementNS(NS, tag);
    for (var k in attrs) e.setAttribute(k, attrs[k]);
    return e;
  }
  function txt(x, y, s, o) {
    o = o || {};
    var attrs = { x: x, y: y, fill: o.fill || '#8b9099', 'font-size': o.size || 10,
      'text-anchor': o.anchor || 'start', 'font-weight': o.weight || 400 };
    if (o.head) attrs['class'] = 'h'; /* .cbm-chart text.h -> heading font (resolves var()) */
    var t = el('text', attrs);
    if (o.ls) t.setAttribute('letter-spacing', o.ls);
    t.textContent = s;
    return t;
  }

  /* -- multi-series line panel (power / torque / boost) -------------------- */
  /* opts: { series:[{rpm,val,color,dash,faded}], yMax, yStep, unit, title,
            right:{factor,unit}, w, h } */
  function linePanel(host, opts) {
    var P = palette(), w = opts.w || 1080, h = opts.h || 300;
    var padL = 46, padR = opts.right ? 46 : 16, padT = 22, padB = 24;
    var xMin = 2000, xMax = 7000, iw = w - padL - padR, ih = h - padT - padB;
    var sx = function (r) { return padL + (r - xMin) / (xMax - xMin) * iw; };
    var sy = function (v) { return padT + ih - (v / opts.yMax) * ih; };
    var svg = el('svg', { viewBox: '0 0 ' + w + ' ' + h, preserveAspectRatio: 'xMidYMid meet',
      class: 'cbm-chart' });
    svg.appendChild(el('rect', { x: padL, y: padT, width: iw, height: ih, fill: P.plot,
      stroke: P.line }));
    for (var v = 0; v <= opts.yMax + 1e-6; v += opts.yStep) {
      var y = sy(v);
      svg.appendChild(el('line', { x1: padL, x2: padL + iw, y1: y, y2: y, stroke: P.grid }));
      svg.appendChild(txt(padL - 6, y + 3.5, Math.round(v), { fill: P.axis, anchor: 'end' }));
      if (opts.right) svg.appendChild(txt(padL + iw + 6, y + 3.5, Math.round(v * opts.right.factor),
        { fill: P.axis, anchor: 'start' }));
    }
    for (var r = xMin; r <= xMax; r += 1000) {
      var x = sx(r);
      svg.appendChild(el('line', { x1: x, x2: x, y1: padT, y2: padT + ih, stroke: P.grid }));
      svg.appendChild(txt(x, padT + ih + 15, (r / 1000) + 'k', { fill: P.axis, anchor: 'middle' }));
    }
    opts.series.forEach(function (se) {
      var pts = se.rpm.map(function (rr, j) { return { x: sx(rr), y: sy(se.val[j]) }; });
      var a = { d: smooth(pts), fill: 'none', stroke: se.color,
        'stroke-width': se.faded ? 1.6 : 2.4, 'stroke-linejoin': 'round', 'stroke-linecap': 'round' };
      if (se.dash) a['stroke-dasharray'] = '7 5';
      if (se.faded) a.opacity = 0.75;
      svg.appendChild(el('path', a));
    });
    svg.appendChild(txt(padL, 14, opts.unit, { fill: P.onMuted, size: 11, weight: 700,
      head: true }));
    if (opts.right) svg.appendChild(txt(padL + iw, 14, opts.right.unit, { fill: P.onMuted, size: 11,
      weight: 700, anchor: 'end', head: true }));
    if (opts.title) svg.appendChild(txt(padL + iw / 2, 14, opts.title, { fill: P.on, size: 12.5,
      weight: 800, anchor: 'middle', ls: 2.5, head: true }));
    host.innerHTML = ''; host.appendChild(svg);
  }

  /* -- interactive drive-mode boost curve ---------------------------------- */
  /* opts: { modes:[{key,name,colorVar,dynoKey,factor,note}] } */
  function driveModes(root, cfg) {
    if (!root || root.dataset.cbmInit) return; root.dataset.cbmInit = '1';
    var svgHost = root.querySelector('[data-chart]'),
        legend = root.querySelector('[data-legend]'),
        note = root.querySelector('[data-note]'),
        btns = [].slice.call(root.querySelectorAll('[data-mode]'));
    var current = cfg.start || 'n';
    function modeCfg(k) { for (var i = 0; i < cfg.modes.length; i++) if (cfg.modes[i].key === k) return cfg.modes[i]; }

    function render() {
      var D = window.CBM_DYNO; if (!D) return;
      var P = palette(), m = modeCfg(current), color = P[m.colorVar] || P.n;
      var w = 820, h = 320, padL = 48, padR = 18, padT = 20, padB = 30, MAXP = 24;
      var xMin = 2000, xMax = 7000, iw = w - padL - padR, ih = h - padT - padB;
      var sx = function (r) { return padL + (Math.max(xMin, Math.min(xMax, r)) - xMin) / (xMax - xMin) * iw; };
      var sy = function (v) { return padT + (1 - Math.min(v, MAXP) / MAXP) * ih; };
      // delivered curve for this mode
      var dRpm, dVal;
      if (m.dynoKey && D[m.dynoKey]) { dRpm = D[m.dynoKey].rpm; dVal = D[m.dynoKey].boost; }
      else { // synthesized (Sport): blend N + Normal
        dRpm = D.N.rpm; dVal = D.N.boost.map(function (v, i) { return (v + D.Normal.boost[i]) / 2; });
      }
      if (m.factor && m.factor !== 1) dVal = dVal.map(function (v) { return v * m.factor; });
      var rs = resample(dRpm, dVal, 650);
      var st = resample(D.Stock.rpm, D.Stock.boost, 650);

      var svg = el('svg', { viewBox: '0 0 ' + w + ' ' + h, class: 'cbm-chart' });
      var defs = el('defs', {}); var gid = 'cbmfill-' + (root.id || 'x');
      var grad = el('linearGradient', { id: gid, x1: 0, x2: 0, y1: 0, y2: 1 });
      grad.appendChild(el('stop', { offset: 0, 'stop-color': color, 'stop-opacity': 0.28 }));
      grad.appendChild(el('stop', { offset: 1, 'stop-color': color, 'stop-opacity': 0 }));
      defs.appendChild(grad); svg.appendChild(defs);
      // y grid (0..24 psi, every 6)
      [0, 6, 12, 18, 24].forEach(function (v) {
        var y = sy(v);
        svg.appendChild(el('line', { x1: padL, x2: w - padR, y1: y, y2: y, stroke: P.grid }));
        svg.appendChild(txt(padL - 8, y + 3.5, v, { fill: P.axis, anchor: 'end' }));
      });
      for (var r = xMin; r <= xMax; r += 1000)
        svg.appendChild(txt(sx(r), h - 10, (r / 1000) + 'k', { fill: P.axis, anchor: 'middle', size: 10.5 }));
      svg.appendChild(txt(padL, 12, 'BOOST · PSI', { fill: P.onMuted, size: 11, weight: 700,
        head: true, ls: 1 }));
      // area + curves
      var dpts = rs.rpm.map(function (rr, j) { return { x: sx(rr), y: sy(rs.val[j]) }; });
      var by = sy(0);
      var area = smooth(dpts) + ' L' + dpts[dpts.length - 1].x.toFixed(1) + ',' + by.toFixed(1) +
        ' L' + dpts[0].x.toFixed(1) + ',' + by.toFixed(1) + ' Z';
      svg.appendChild(el('path', { d: area, fill: 'url(#' + gid + ')' }));
      var spts = st.rpm.map(function (rr, j) { return { x: sx(rr), y: sy(st.val[j]) }; });
      svg.appendChild(el('path', { d: smooth(spts), fill: 'none', stroke: P.stock,
        'stroke-width': 2, 'stroke-linejoin': 'round', 'stroke-linecap': 'round' }));
      svg.appendChild(el('path', { d: smooth(dpts), fill: 'none', stroke: color,
        'stroke-width': 3.5, 'stroke-linejoin': 'round', 'stroke-linecap': 'round' }));
      svgHost.innerHTML = ''; svgHost.appendChild(svg);

      var peak = Math.round(Math.max.apply(null, dVal));
      legend.innerHTML = '<span><i style="background:' + color + '"></i>Delivered — ' + m.name +
        ' mode · ~' + peak + ' psi peak</span><span><i style="height:2px;background:' + P.stock +
        '"></i>Stock</span>';
      if (note) note.textContent = m.note || '';
      btns.forEach(function (b) {
        var on = b.getAttribute('data-mode') === current;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.style.setProperty('--cbm-accent', on ? color : '');
      });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () { current = b.getAttribute('data-mode'); render(); });
    });
    boot(render);
  }

  /* -- power/torque/boost by mode (static multi-series) -------------------- */
  function dynoResults(root, cfg) {
    if (!root || root.dataset.cbmInit) return; root.dataset.cbmInit = '1';
    boot(function () {
      var D = window.CBM_DYNO; if (!D) return;
      var P = palette();
      var order = ['Stock', 'Eco', 'Normal', 'N'];
      var col = { N: P.n, Normal: P.normal, Eco: P.eco, Stock: P.stock };
      var dash = { Stock: true }, faded = { Stock: true };
      function series(field) {
        return order.map(function (k) {
          return { rpm: D[k].rpm, val: D[k][field], color: col[k], dash: dash[k], faded: faded[k] };
        });
      }
      var pw = root.querySelector('[data-power]'), tq = root.querySelector('[data-torque]'),
          bo = root.querySelector('[data-boost]');
      if (pw) linePanel(pw, { series: series('kwAtw'), yMax: 175, yStep: 25, unit: 'kW (ATW)',
        right: { factor: 1.5945, unit: 'HP (fly)' }, title: 'POWER', w: 1080, h: 300 });
      if (tq) linePanel(tq, { series: series('tqFly'), yMax: 450, yStep: 75, unit: 'Nm (fly)',
        title: 'TORQUE', w: 540, h: 240 });
      if (bo) linePanel(bo, { series: series('boost'), yMax: 25, yStep: 5, unit: 'PSI',
        title: 'BOOST', w: 540, h: 240 });
      // result cards
      var host = root.querySelector('[data-cards]');
      if (host) {
        var sHp = D.Stock.peak.hpFly, sTq = D.Stock.peak.tqFly;
        var names = { N: 'N Mode', Normal: 'Normal Mode', Eco: 'Eco Mode', Stock: 'Stock' };
        function sgn(n) { return (n >= 0 ? '+' : '−') + Math.abs(Math.round(n)); }
        host.innerHTML = ['N', 'Normal', 'Eco', 'Stock'].map(function (k) {
          var c = col[k], pk = D[k].peak;
          var atw = Math.round(pk.kwAtw) + ' kW / ' + Math.round(pk.tqAtw) + ' Nm';
          var fly = Math.round(pk.hpFly) + ' BHP / ' + Math.round(pk.tqFly) + ' Nm';
          var foot = k === 'Stock' ? '<span class="cbm-delta cbm-delta--flat">Factory baseline</span>'
            : '<span class="cbm-delta">' + sgn(pk.hpFly - sHp) + ' BHP  /  ' + sgn(pk.tqFly - sTq) + ' Nm</span>';
          return '<div class="cbm-rescard" style="--cbm-accent:' + c + '">' +
            '<div class="cbm-rescard-h"><span class="cbm-rescard-n">' + names[k] + '</span>' +
            '<span class="cbm-pill"><b>' + Math.round(pk.boost) + '</b><span>PSI</span></span></div>' +
            '<div class="cbm-big"><b>' + atw + '</b><span class="cbm-chip">ATW</span></div>' +
            '<div class="cbm-big cbm-big--sec"><b>' + fly + '</b><span class="cbm-chip">FLY</span></div>' +
            foot + '</div>';
        }).join('');
      }
    });
  }

  /* -- patched vs unpatched "real gains" ----------------------------------- */
  /* opts: { divergeRpm, dropFrac }  patched = N; unpatched = N tapered past diverge */
  function gains(root, opts) {
    if (!root || root.dataset.cbmInit) return; root.dataset.cbmInit = '1';
    opts = opts || {}; var divergeRpm = opts.divergeRpm || 4750, dropFrac = opts.dropFrac || 0.11;
    boot(function () {
      var D = window.CBM_DYNO; if (!D) return;
      var P = palette();
      function taper(rpm) {
        return rpm.map(function (r) {
          if (r <= divergeRpm) return 1;
          var t = (r - divergeRpm) / (6900 - divergeRpm);
          return 1 - dropFrac * t;
        });
      }
      function panelWithZone(host, field, yMax, yStep, unit, right, title) {
        var patched = { rpm: D.N.rpm, val: D.N[field], color: P.n };
        var tf = taper(D.N.rpm);
        var unpatched = { rpm: D.N.rpm, val: D.N[field].map(function (v, i) { return v * tf[i]; }),
          color: P.stock };
        // draw base panel then overlay zone by re-using linePanel then adding a rect is hard;
        // build here so we can shade under the diverge line.
        var w = 1080, h = right ? 300 : 210, padL = 46, padR = right ? 46 : 16, padT = 22, padB = 24;
        var xMin = 2000, xMax = 7000, iw = w - padL - padR, ih = h - padT - padB;
        var sx = function (r) { return padL + (r - xMin) / (xMax - xMin) * iw; };
        var sy = function (v) { return padT + ih - (v / yMax) * ih; };
        var svg = el('svg', { viewBox: '0 0 ' + w + ' ' + h, preserveAspectRatio: 'xMidYMid meet',
          class: 'cbm-chart' });
        svg.appendChild(el('rect', { x: padL, y: padT, width: iw, height: ih, fill: P.plot, stroke: P.line }));
        // shaded gains zone
        var zx = sx(divergeRpm);
        svg.appendChild(el('rect', { x: zx, y: padT, width: padL + iw - zx, height: ih,
          fill: P.n, opacity: 0.09 }));
        svg.appendChild(el('line', { x1: zx, x2: zx, y1: padT, y2: padT + ih, stroke: P.n,
          opacity: 0.5, 'stroke-dasharray': '4 4' }));
        if (right) svg.appendChild(txt((zx + padL + iw) / 2, padT + 13, 'THE GAINS · ' +
          Math.round(divergeRpm / 50) * 50 + ' RPM +', { fill: P.n, anchor: 'middle', size: 10.5,
          weight: 800, ls: 1, head: true }));
        for (var v = 0; v <= yMax + 1e-6; v += yStep) {
          var y = sy(v);
          svg.appendChild(el('line', { x1: padL, x2: padL + iw, y1: y, y2: y, stroke: P.grid }));
          svg.appendChild(txt(padL - 6, y + 3.5, Math.round(v), { fill: P.axis, anchor: 'end' }));
          if (right) svg.appendChild(txt(padL + iw + 6, y + 3.5, Math.round(v * right.factor),
            { fill: P.axis, anchor: 'start' }));
        }
        for (var r = xMin; r <= xMax; r += 1000) {
          var x = sx(r);
          svg.appendChild(txt(x, padT + ih + 15, (r / 1000) + 'k', { fill: P.axis, anchor: 'middle' }));
        }
        [unpatched, patched].forEach(function (se, idx) {
          var pts = se.rpm.map(function (rr, j) { return { x: sx(rr), y: sy(se.val[j]) }; });
          svg.appendChild(el('path', { d: smooth(pts), fill: 'none', stroke: se.color,
            'stroke-width': idx === 1 ? 3 : 2.4, 'stroke-linejoin': 'round', 'stroke-linecap': 'round' }));
        });
        svg.appendChild(txt(padL, 14, unit, { fill: P.onMuted, size: 11, weight: 700,
          head: true }));
        if (right) svg.appendChild(txt(padL + iw, 14, right.unit, { fill: P.onMuted, size: 11,
          weight: 700, anchor: 'end', head: true }));
        svg.appendChild(txt(padL + iw / 2, 14, title, { fill: P.on, size: 12.5, weight: 800,
          anchor: 'middle', ls: 2.5, head: true }));
        host.innerHTML = ''; host.appendChild(svg);
      }
      var pw = root.querySelector('[data-power]'), bo = root.querySelector('[data-boost]');
      if (pw) panelWithZone(pw, 'kwAtw', 175, 25, 'kW (ATW)', { factor: 1.5945, unit: 'HP (fly)' }, 'POWER');
      if (bo) panelWithZone(bo, 'boost', 25, 5, 'PSI', null, 'BOOST');
      var lg = root.querySelector('[data-legend]');
      if (lg) lg.innerHTML = '<span><i style="background:' + P.n + '"></i>Patched — Cherry Custom Boost Model</span>' +
        '<span><i style="background:' + P.stock + '"></i>Unpatched — factory boost logic</span>';
    });
  }

  /* -- calibration heatmap -------------------------------------------------- */
  /* opts: { cols:[labels], rows:[labels], data:[[..]], accent:'red'|'teal',
            fmt } — accent picks the colour ramp */
  function heatmap(host, opts) {
    var P = palette();
    var acc = opts.accent === 'teal' ? hex2rgb(P.eco) : hex2rgb(P.n);
    var base = [18, 20, 22];
    var flat = []; opts.data.forEach(function (r) { r.forEach(function (v) { flat.push(v); }); });
    var min = opts.min != null ? opts.min : Math.min.apply(null, flat);
    var max = opts.max != null ? opts.max : Math.max.apply(null, flat);
    function cell(v) {
      var t = max === min ? 1 : (v - min) / (max - min);
      t = 0.12 + 0.88 * t;
      var c = base.map(function (b, i) { return Math.round(b + (acc[i] - b) * t); });
      return 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ')';
    }
    var h = '<table class="cbm-heat"><thead><tr><th class="rh"></th>';
    opts.cols.forEach(function (c) { h += '<th>' + c + '</th>'; });
    h += '</tr></thead><tbody>';
    opts.data.forEach(function (row, ri) {
      h += '<tr><td class="rh">' + opts.rows[ri] + '</td>';
      row.forEach(function (v) {
        h += '<td style="background:' + cell(v) + '">' + (opts.fmt ? opts.fmt(v) : v) + '</td>';
      });
      h += '</tr>';
    });
    host.innerHTML = h + '</tbody></table>';
  }

  /* -- PID correction bar chart (V-shape effort vs error) ------------------ */
  function correction(host, opts) {
    var P = palette(), w = 620, h = 250, base = 202, top = 24;
    var buckets = opts && opts.buckets || [0.48, 0.26, 0.16, 0, 0.16, 0.26, 0.48, 1];
    var mid = 3; // "on target" bucket index
    var svg = el('svg', { viewBox: '0 0 ' + w + ' ' + h, class: 'cbm-chart' });
    var n = buckets.length, gap = 10, bw = (w - 40 - gap * (n - 1)) / n, x0 = 32;
    buckets.forEach(function (val, i) {
      var bh = (base - top) * val, x = x0 + i * (bw + gap), y = base - bh;
      var isMid = i === mid;
      svg.appendChild(el('rect', { x: x, y: isMid ? base - 3 : y, width: bw, height: isMid ? 3 : bh,
        rx: 2, fill: isMid ? P.good : P.n, opacity: isMid ? 1 : (0.55 + 0.45 * val) }));
    });
    svg.appendChild(txt(26, 15, 'MORE CORRECTION EFFORT ▲', { fill: P.onMuted, size: 11, weight: 700,
      head: true, ls: 0.5 }));
    svg.appendChild(txt(26, h - 8, '◀ boost below target', { fill: P.axis, size: 11, weight: 700,
      head: true }));
    svg.appendChild(txt(w - 20, h - 8, 'boost above target ▶', { fill: P.axis, size: 11, weight: 700,
      anchor: 'end', head: true }));
    var mx = x0 + mid * (bw + gap) + bw / 2;
    svg.appendChild(txt(mx, base - 16, 'ON TARGET', { fill: P.good, size: 10.5, anchor: 'middle',
      weight: 700, head: true }));
    svg.appendChild(txt(mx, base - 5, 'no correction', { fill: P.good, size: 8.5, anchor: 'middle' }));
    host.innerHTML = ''; host.appendChild(svg);
  }

  function hex2rgb(h) {
    h = (h || '').trim();
    if (h[0] === '#') h = h.slice(1);
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    if (isNaN(n)) return [204, 51, 51];
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function boot(fn) { if (window.CBM_DYNO) fn(); else setTimeout(function () { boot(fn); }, 60); }

  window.CBM = { smooth: smooth, linePanel: linePanel, driveModes: driveModes,
    dynoResults: dynoResults, gains: gains, heatmap: heatmap, correction: correction };
})();
